export default __webpack_public_path__ + "static/media/ai-flag.bd470188.svg";